import React, { ChangeEventHandler } from 'react';
import classNames from 'classnames';
import { RCCheckableLabel } from '../RCCheckbox/RCCheckableLabel';
import type { FormattedString } from '../../types';

export interface IRCRadioProps {
  label: FormattedString;
  sublabel?: string;
  name: string;
  id: string;
  value: string;
  checked: boolean;
  onChange: ChangeEventHandler<HTMLInputElement>;
  disabled?: boolean;
}

/**
 * Internal-only component for rendering a radio input.
 * Use <Option> inside RCRadios when you need to render radios
 */
export function RadioImpl(props: IRCRadioProps) {
  return (
    <span className={classNames(
      'rc-radio',
      { 'rc-radio--disabled': props.disabled },
    )}>
      <input
        className="rc-radio__input"
        type="radio"
        name={props.name}
        id={props.id}
        value={props.value}
        checked={props.checked}
        onChange={props.onChange}
        disabled={props.disabled}
      />
      <span className="rc-radio__circle" />
      <RCCheckableLabel
        for={props.id}
        label={props.label}
        sublabel={props.sublabel}
      />
    </span>
  );
}
